import {
    Box,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import Title1 from '../../components/title/title1';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import companyData from '../../data/company.json';

const PolicyView = ({
    data
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <Title1 
                        title={data.title}
                        description={data.updated}
                    />

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='center'
                        width='100%'
                        spacing={{xs: 2, md: 3}}
                    >
                        {
                            data.content.map((item, index) => {
                                return <PolicyBody 
                                    key={index}
                                    title={item.title}
                                    description={item.description}
                                />
                            })
                        }
                    </Stack>

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='start'
                        width='100%'
                        pt={{xs: 2, md: 4}}
                        spacing={{xs: 0, md: 0.5}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('company')}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {`${t('footer.address1.no')}, ${t('footer.address1.road')}, ${t('footer.address1.city')}, ${t('footer.address1.country')}`}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            <Link
                                to={companyData.socialMedia[0].link}
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.socialMedia[0].label}
                            </Link>
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            <Link
                                to={companyData.socialMedia[1].link}
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.socialMedia[1].label}
                            </Link>
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}

export default PolicyView;

const PolicyBody = ({
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                spacing={{xs: 1, md: 1.5}}
            >  
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 14, md: 16}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 14}}
                    textAlign="justify"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}